<template>
    <ConditionalTransition name="slide"
                           :disabled="disabled">
        <slot />
    </ConditionalTransition>
</template>

<script setup lang="ts">
    import { toRefs } from 'vue';
    import ConditionalTransition from './ConditionalTransition.vue';
    import { TMenuItemHeight } from '../global/menu/types/menuTypes';

    const props = defineProps<{
        disabled: boolean,
        childHeight: TMenuItemHeight,
        childCount: number,
    }>();

    const { childHeight, childCount } = toRefs(props);
</script>

<style scoped lang="scss">
$transition-time: 200ms;

.slide-enter-active,
.slide-leave-active {
    transition: all $transition-time ease-in-out;
}

.slide-enter-from,
.slide-leave-to {
    height: 0;
}

.slide-enter-to,
.slide-leave-from {
    height: calc(v-bind(childCount) * v-bind(childHeight));
}
</style>
